/** @module Camunda/CamundaTaskViewActivityPopupController */
define([
	"dojo/_base/declare",
	"csi/action/PopupController",
], function (declare, PopupController) {

	return declare(PopupController, {
		/**
		 * @override
		 * Add CSS class to dialog
		 */
		onCreatePopupDialogParams: function (dialogParams) {
			dialogParams["class"] = "csi-flex-dialog";
			dialogParams["bMaxSize"] = true;
		},
	});
});
